import { Component } from '@angular/core';

@Component({
  selector: 'app-testimonials',
  standalone: true,
  templateUrl: './testimonials.component.html',
  styleUrl: './testimonials.component.scss',
})
export class TestimonialsComponent {
  stats = [
    { value: '300+', label: 'wesel' },
    { value: '18 000+', label: 'gości w grze' },
    { value: '4,9/5', label: 'średnia ocen' },
  ];

  testimonials = [
    { quote: 'Baliśmy się nudnych momentów. Goście do dziś wspominają tę grę.', name: 'Ania & Marek', role: 'Para Młoda' },
    { quote: 'Dodałem to do oferty i mam czym się wyróżnić. Prowadzi się samo.', name: 'DJ Kuba', role: 'DJ / Prowadzący' },
    { quote: 'Pierwszy raz grałem w coś na weselu bez wstawania od stołu.', name: 'Tomek', role: 'Gość weselny' },
  ];
}
